jQuery(document).ready( function($) {
	
	$('.wp-block-image, .wp-block-gallery, .wp-block-embed').attr('data-aos', 'fade-up');
	
	AOS.init( {
		offset: 100,
		duration: 600,
		easing: 'ease-in-out',
	} );
	
} );